import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=c4d9b31a"
import script from "../controllers/about-us.js?vue&type=script&lang=js&external"
export * from "../controllers/about-us.js?vue&type=script&lang=js&external"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=c4d9b31a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports